<template>
  <c-row>
    <c-col>
      <c-card>
        <loader v-show="loading" />
        <c-card-header>
          <strong>Transaksi Berhasil</strong>
          <div class="card-header-actions" v-show="isSearch">
            <CInput @keyup="doSearch" type="text" placeholder="Ketikan sesuatu kemudian tekan enter" v-model="q"
              style="width: 400px" ref="search">
              <template #append-content>
                <a @click="hideSearch">
                  <i class="cil-chevron-circle-right-alt"></i>
                </a>
              </template>
            </CInput>
          </div>
          <div class="card-header-actions" v-show="!isSearch">
            <a class="link btn btn-outline-success" @click="addNew">
              <i class="cil-plus"></i>
            </a>
            <a class="link btn btn-outline-info" @click="showSearch">
              <i class="cil-search"></i>
            </a>
          </div>
        </c-card-header>
        <c-card-body style="overflow: auto">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Invoice</th>
                <th>Customer</th>
                <th>Created By</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in data.data" :key="k">
                <td class="center">
                  <table-number-2 :index="k" :paginate="data.paginate" />
                </td>
                <td>{{ v.invoice }}</td>
                <td>{{ v.customer_name }}</td>
                <td>{{ v.user_name }}</td>
                <td>{{ v.created_at | dateFormat }}</td>
                <td>
                  <button class="btn-outline-info btn btn-action" @click="doPrint(v.id)" v-c-tooltip.click="'Print'">
                    <i class="cil-print"></i>
                  </button>
                  <button class="btn-outline-warning btn btn-action" @click="doEdit(v.id)" v-c-tooltip.click="'Edit'">
                    <i class="cil-pencil"></i>
                  </button>
                  <button class="btn-outline-danger btn btn-action" @click="doDelete(v)" v-if="!v.deleted_at"
                    v-c-tooltip.click="'Delete'">
                    <i class="cil-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </c-card-body>
        <c-card-footer>
          <paginator :paginator="data.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
    <CModal title="Delete Confirmation" size="sm" color="danger" :show.sync="deleteConfirm" v-if="deletedObject">
      Yakin Akan menghapus data {{ deletedObject.name }}?
      <textarea placeholder="alasan dihapus (max: 200)" class="form-control" v-model="delReason" maxlength="200" />
      <template #footer>
        <CButton @click="deleteConfirm = false" color="danger">Batal</CButton>
        <CButton @click="runDelete" color="success">Yakin</CButton>
      </template>
    </CModal>
  </c-row>
</template>
<script>
import Loader from '../../components/Loader.vue';
import Paginator from '../../components/Paginator.vue';
import TableNumber2 from '../../components/TableNumber2.vue';
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from '../../lib/httplib';
export default {
  components: {
    Loader,
    TableNumber2,
    Paginator,
  },
  data () {
    return {
      loading: false,
      isSearch: false,
      q: '',
      data: {},
      deletedObject: null,
      deleteConfirm: false,
      delReason: ''
    }
  },
  created () {
    const query = this.$route.query;
    if (query.search === "true") {
      this.isSearch = query.search;
    }
    if (query.q) {
      this.loadData(1, query.q);
      this.q = query.q;
      return;
    }
    this.loadData(1, "");
  },
  methods: {
    doSearch (e) {
      if (e.keyCode === 13) {
        this.loadData(1, this.q);
        this.$router.push({ query: { search: true, q: this.q } });
      }
    },
    changePage (page) {
      this.loadData(page, this.q)
    },
    loadData (page, q) {
      this.loading = true
      HTTPAUTH.get(`/api/v1/sale/success?q=${q}&page=${page}&size=10`).then((res) => {
        this.data = res.data;
        this.loading = false
      }).catch(eres => {
        this.loading = false
        showErrorMessage(eres)
      });
    },
    hideSearch () {
      this.isSearch = false;
      this.$router.push({ query: { search: false } });
      this.q = "";
      this.loadData(1, "");
    },
    showSearch () {
      this.isSearch = true;
      this.$router.push({ query: { search: true } });
    },
    addNew () {
      this.$router.push({ path: this.editRoute });
    },
    doEdit (id) {
      this.$router.push({ path: "/kasir", query: { id: id } });
    },
    doDelete (o) {
      this.deletedObject = o;
      this.deleteConfirm = true;
    },
    doPrint (id) {
      window.open("#/print/kasir/faktur/" + id, "_blank")
    },
    runDelete () {
      HTTPAUTH.delete(`/api/v1/sale/${this.deletedObject.id}?r=${this.delReason}`)
        .then(() => {
          this.$toasted.success("Hapus data berhasil").goAway(3000);
          this.deleteConfirm = false;
          this.loadData(1, '');
          this.delReason = '';
        })
        .catch(eres => {
          this.$toasted.error(eres.response.statusText).goAway(3000);
          this.deleteConfirm = false;
          this.delReason = '';
        });
    },
  }
};
</script>